import { render } from "./picture.vue?vue&type=template&id=dddd6de2&scoped=true&ts=true"
import script from "./picture.vue?vue&type=script&lang=ts"
export * from "./picture.vue?vue&type=script&lang=ts"

import "./picture.vue?vue&type=style&index=0&id=dddd6de2&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src245414373/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-dddd6de2"]])

export default __exports__